import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';
import { ruleRowNameSize, ruleRowFieldsSize, row } from './utils';
import RuleRowHeader from './ruleRowHeader';

const InactiveRule = props => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Grid container item xs={row} classes={{ root: classes.EventTypeForm }}>
      <Grid item {...ruleRowNameSize} className={classes.EventTypeNameField}>
        <RuleRowHeader
          headerText={t(`eventType.${props.eventType}`)}
          eventType={props.eventType}
          index={-1}
          showDeleteButton={false}
        />
      </Grid>
      <Grid
        container
        item
        justifyContent="flex-start"
        alignItems="center"
        {...ruleRowFieldsSize}
        className={classes.RuleFields}
      >
        <em className={classes.InactiveRule}>
          {t('positionPage.inactiveRule')}
        </em>
      </Grid>
    </Grid>
  );
};

InactiveRule.propTypes = {
  eventType: PropTypes.string,
  hover: PropTypes.bool,
};

export default React.memo(InactiveRule);
